export default __webpack_public_path__ + "static/media/iam_background_m2.27f4c5a5.jpg";